// extracted by mini-css-extract-plugin
module.exports = {"content":"contact__content___1Aket","qrcode":"contact__qrcode___1fPfA"};